/** Return / Pause / sidebar docking and FPS anchor layout. */

export type PlayHudLayoutOptions = {
    invertReturnPause: boolean;
    invertSidebar: boolean;
};

let invertReturnPause = false;
let invertSidebar = false;

export function setPlayHudLayoutOptions(opts: PlayHudLayoutOptions) {
    invertReturnPause = opts.invertReturnPause;
    invertSidebar = opts.invertSidebar;
    applyPlayHudLayoutClasses();
}

export function setPlayHudSidebarCollapsed(_collapsed: boolean) {
    /* sidebar open state read from DOM in syncReturnButtonDock */
}

function applyPlayHudLayoutClasses() {
    document.body.classList.toggle("invert-return-pause", invertReturnPause);
    document.body.classList.toggle("invert-sidebar", invertSidebar);
}

export function syncReturnButtonDock() {
    const returnBtn = document.getElementById("returnBtn");
    const dock = document.getElementById("sideNavReturnDock");
    if (!returnBtn) return;

    if (dock) {
        dock.classList.add("hidden");
        dock.setAttribute("aria-hidden", "true");
    }
    if (returnBtn.parentElement !== document.body) document.body.appendChild(returnBtn);

    returnBtn.classList.remove("playHudReturn--docked", "playHudReturn--menuBelow");
    returnBtn.classList.toggle("playHudReturn--invertRow", invertSidebar);
}

export function syncPlayHudLayout() {
    applyPlayHudLayoutClasses();
    syncReturnButtonDock();
}

export function getFpsAnchorElement(): HTMLElement | null {
    const invert = invertReturnPause && document.body.classList.contains("game-active");
    const id = invert ? "pauseTopBtn" : "returnBtn";
    const el = document.getElementById(id);
    if (!el || el.classList.contains("hidden")) return null;
    return el;
}
